import React from 'react'
import className from 'classnames'
import PropTypes from 'prop-types'
import { withProps } from 'recompose'
import { isTouchScreen } from '../../../../lib/utils/viewport'
import { noop } from '../../../../lib/utils/common'

const htmlLabel = (name, matchText) => {
  if (matchText) {
    const regexp = new RegExp(matchText, 'gi')
    const resultNameHtml = name.replace(regexp, text => (
      `<span class='Multiselect-matchText'>${text}</span>`
    ))

    return(
      <span dangerouslySetInnerHTML={{__html: resultNameHtml}} />
    )
  }

  return name
}

const enhance = withProps(({option, matchText, optionLabel}) => ({
  labelText: htmlLabel(optionLabel(option), matchText)
}))

const Option = ({
  option, optionTemplate, onSelect, isActive, isHighlighted,
  onMouseEnter, onMouseLeave, labelText, activeRef, isSelectedGroup, isChild
}) => (
  <div
    className={className('Multiselect-option', { isActive: isHighlighted, isSelectedGroup, isChild })}
    onClick={() => { onSelect(option) }}
    onMouseEnter={isTouchScreen() ? noop : () => onMouseEnter(option)}
    onMouseLeave={isTouchScreen() ? noop : () => onMouseLeave(option)}
    ref={activeRef(option)}
  >
    <div className='Checkbox'>
      <label className='Checkbox-label'>
        <input
          type='checkbox'
          checked={isActive}
          onChange={noop}
          onClick={e => { e.stopPropagation() }}
          className='Checkbox-input'
        />
        <span className='Checkbox-icon' />

        { optionTemplate({option, labelText, isActive}) }
      </label>
    </div>
  </div>
)

Option.defaultProps = {
  matchText: '',
  isSelectedGroup: false
}

Option.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  optionTemplate: PropTypes.func.isRequired,
  option: PropTypes.any.isRequired,
  isActive: PropTypes.bool.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  labelText: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]).isRequired,
  matchText: PropTypes.string,
  activeRef: PropTypes.func.isRequired,
  isSelectedGroup: PropTypes.bool,
  isChild: PropTypes.bool
}

export default enhance(Option)
